import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import P1DoctorSetupWrapper from './P1DoctorSetupWrapper';

loadDOMComponent({
	selector: 'react-p1-setup-wrapper',
	callback: ({ container, context }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<P1DoctorSetupWrapper />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
